import { jsx } from "react/jsx-runtime";
import { useColorPicker } from "../hooks/useColorPicker.js";
import { AddColorToPalette } from "./AddColorToPalette.js";
function ColorPickerRouter(props) {
  const {
    router: { route }
  } = useColorPicker();
  const { palette, picker } = props;
  switch (route.id) {
    case "palette": {
      if (!palette) {
        const message = "palette component should be provided";
        console.error(message);
        return /* @__PURE__ */ jsx("div", { children: message });
      }
      return palette;
    }
    case "add-color-to-palette":
      return /* @__PURE__ */ jsx(AddColorToPalette, { group: route.group });
    case "custom": {
      if (!picker) {
        const message = "picker component should be provided";
        console.error(message);
        return /* @__PURE__ */ jsx("div", { children: message });
      }
      return picker;
    }
  }
}
export {
  ColorPickerRouter
};
//# sourceMappingURL=ColorPickerRouter.js.map
